import { useEffect, useRef } from "react";

import { GTMPushEvent } from "@/src/helpers/google-tag-manager";

import styles from "./styles.module.css";

const AkbankBanner = () => {
  const bannerRef = useRef(null);
  // const impressionSent = useRef(false);

  const clickUrl =
    "https://mza5.tr.adj.st/akbankdirekt?function=609&widget=true&adj_t=1rwlspmw&adj_deep_link=akbankdirekt%3A%2F%2Fsplash%2Ffunction%2F609&adj_fallback=https%3A%2F%2Fwww.akbank.com%2Fbasvuru%2Fmobileappservice%2F%23&adj_redirect_macos=https%3A%2F%2Fwww.akbank.com%2Fbasvuru%2Fmobileappservice%2F%23";

  const handleClickAkbankBanner = () => {
    GTMPushEvent({
      event: "ga4_event",
      event_name: "ilan_banner",
      event_parameters: {
        widget: "akbank_kampanya",
      },
    });
  };

  // const impressionUrl = '';

  // useEffect(() => {
  //   if (!bannerRef.current) return;

  //   const observer = new IntersectionObserver(
  //     ([entry]) => {
  //       if (entry.isIntersecting && !impressionSent.current) {
  //         impressionSent.current = true;
  //         fetch(impressionUrl, { method: 'GET', mode: 'no-cors' });
  //         observer.disconnect();
  //       }
  //     },
  //     { threshold: 1 },
  //   );

  //   observer.observe(bannerRef.current);

  //   return () => observer.disconnect();
  // }, []);

  return (
    <div ref={bannerRef} className={styles.bannerContainer}>
      <a
        href={clickUrl}
        rel="sponsored nofollow noreferrer"
        onClick={handleClickAkbankBanner}
        title="Akbank advertisement"
      >
        <img src="/assets/images/newAkbankDesktopBanner.jpg" alt="akbank-banner" className={styles.bannerImage} />
      </a>
    </div>
  );
};

export default AkbankBanner;
